import { $themeBreakpoints } from '@themeConfig'
import db from '@/models/system'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    system: null,
    currentTablePage: 1,
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    SET_CURRENT_TABLE_PAGE(state, payload) {
      state.currentTablePage = payload
    },
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    SET_SYSTEM(state, val) {
      state.system = val
    },
  },
  actions: {
    async fetchSystem({ commit }) {
      const data = await db.get()
      commit('SET_SYSTEM', data)
    },
  },
}
